import React from 'react';
import Logo from '../../assets/images/TELUS-logo-white.gif';
import EN from '../../EN.json';
import FR from '../../FR.json';

const Footer = () => {
  const {
    USERS: {
      USER_AUTHENTICATION:{
        FOOTER: {
          MESSAGE
        }
      }

    }
  } =  localStorage.getItem('locale') ? (localStorage.getItem('locale') === 'EN' ? EN : FR) : EN;
  return (
    <div id="footer">
      <div id="footer-wrapper">
        <div align="center" id="footer-wrapper-copyright">
          <div>
            <img src={Logo} title="TELUS" alt="logo-img" />
          </div>
          <div>
            <span className="frg-body-font-14px">
              © {`${new Date().getFullYear()} ${MESSAGE}`}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
